import Box from '../../Box/Box';
import { memo } from 'react';
import { Image } from '../../..';
import { LobbyBadgeProps } from './LobbyBadge.types';

function LobbyBadge({ children, imageName, ...boxProps }: LobbyBadgeProps) {
  return (
    <Box
      position="absolute"
      alignItems="center"
      top="space-0"
      width={120}
      zIndex={1}
    >
      <Box
        position="absolute"
        top="space-0"
        transform={'translateY(-10px)'}
        height={24}
        borderRadius="radius-600"
        flexDirection="row"
        gap="space-100"
        justifyContent="center"
        alignItems="center"
        paddingVertical="space-050"
        paddingHorizontal="space-200"
        maxWidth={350}
        {...boxProps}
      >
        {imageName && (
          <Image contentFit="contain" name={imageName} width={20} height={20} />
        )}
        <Box flexDirection="row" gap="space-050">
          {children}
        </Box>
      </Box>
    </Box>
  );
}

export default memo(LobbyBadge);
